import { Grid, FormControlLabel } from "@material-ui/core"
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import { CheckboxSmall, FieldSetStyles } from "../../styles";

type SourceLinkExtractionConfProps = {
    ignoreStaticRedirect: boolean,
    onIgnoreStaticRedirectChange: () => void,
    ignoreDiffbotCanonical: boolean,
    onIgnoreDiffbotCanonicalChange: () => void,
    ignoreStaticCanonical: boolean,
    onIgnoreStaticCanonicalChange: () => void,
    disabled?: boolean
}

export const SourceLinkExtractionConf = ({
    ignoreStaticRedirect,
    onIgnoreStaticRedirectChange,
    ignoreDiffbotCanonical,
    onIgnoreDiffbotCanonicalChange,
    ignoreStaticCanonical,
    onIgnoreStaticCanonicalChange,
    disabled
}: SourceLinkExtractionConfProps) => {

    const fieldSetStyles = FieldSetStyles();

    return <fieldset className={fieldSetStyles.container}>
        <legend>Link extraction settings:</legend>
        <Grid container >
            <Grid item xs={6}>
                <FormControlLabel
                    control={
                        <CheckboxSmall
                            icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                            checkedIcon={<CheckBoxIcon fontSize="small" />}
                            name="ignoreStaticRedirect"
                            checked={ignoreStaticRedirect}
                            onChange={onIgnoreStaticRedirectChange}
                            disabled={disabled}
                        />
                    }
                    label="Ignore server redirects"
                />
            </Grid>
            <Grid item xs={6}>
                <FormControlLabel
                    control={
                        <CheckboxSmall
                            icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                            checkedIcon={<CheckBoxIcon fontSize="small" />}
                            name="ignoreDiffbotCanonical"
                            checked={ignoreDiffbotCanonical}
                            onChange={onIgnoreDiffbotCanonicalChange}
                            disabled={disabled}
                        />
                    }
                    label="Ignore canonical diffbot URL"
                />
            </Grid>
            <Grid item xs={6}>
                <FormControlLabel
                    control={
                        <CheckboxSmall
                            icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                            checkedIcon={<CheckBoxIcon fontSize="small" />}
                            name="ignoreStaticCanonical"
                            checked={ignoreStaticCanonical}
                            onChange={onIgnoreStaticCanonicalChange}
                            disabled={disabled}
                        />
                    }
                    label="Ignore canonical URL"
                />
            </Grid>
        </Grid>
    </fieldset>
}